export const SET_INITIAL_STATS = 'SET_INITIAL_STATS';
export const SWITCH_INVENTORY = 'SWITCH_INVENTORY';
export const CONTINUE_HANDLER = 'CONTINUE_HANDLER';
export const LEVEL_AREA_BOSS_UPDATE = 'LEVEL_AREA_BOSS_UPDATE';
export const CHOOSE_MONSTER = 'CHOOSE_MONSTER';
export const REVEAL_HANDLER = 'REVEAL_HANDLER';
export const ROLL_ATTACK_DICE = 'ROLL_ATTACK_DICE';
export const ROLL_RETALIATION_DICE = 'ROLL_RETALIATION_DICE';
export const CLAIM_REWARDS = 'CLAIM_REWARDS';
export const CHOOSE_REWARD = 'CHOOSE_REWARD';
export const SHOW_MERCHANT = 'SHOW_MERCHANT';
export const CLOSE_MERCHANT = 'CLOSE_MERCHANT';
export const CHECK_LEVELUP = 'CHECK_LEVELUP';
export const CHOOSE_PLANET = 'CHOOSE_PLANET';

